<template>
    <div class="overlay">
        <div class="overlay_inner channel_list">

            <p class="field search-field">
                <input
                    id="vyhledavani2"
                    name="vyhledavani2"
                    type="text"
                    class="search clearable"
                    size="30"
                    v-model="search"
                    :placeholder="$gettext('Vyhledat stanici')"
                />
                <a
                    v-if="search.length > 0"
                    id="vyhledavani_delete2"
                    class="clearable_btn"
                    style="display:inline"
                    :title="$gettext('Vymazat text')"
                    @click.prevent="clearSearch"
                >
                    {{ $gettext('Vymazat') }}
                </a>
            </p>

            <p class="note">{{ $gettext('Vybrané stanice') }}</p>

            <div class="selected_stations">
                <ul>
                    <li v-if="isTvStationShown(tvStation)" v-for="tvStation in sortedTvStations" :key="tvStation._id">
                        <input
                            type="checkbox"
                            :id="'tvStation'+tvStation._id"
                            :name="'tvStation'+tvStation._id"
                            :value="tvStation._id"
                            :checked="selectedTvStations.includes(tvStation)"
                            @change="tvStationChanged($event.target.checked, tvStation)"
                        />
                        <label :for="'tvStation'+tvStation._id">
                            {{ tvStation.name }} <strong>({{ tvStation.numberOfUnassignedBroadcasts }})</strong>
                        </label>
                    </li>
                </ul>
            </div>

            <p class="buttons">
                <input
                    class="btn"
                    type="submit"
                    value="Uložit výběr"
                    @click.prevent="$emit('tvStationsSelected', selectedTvStations)"
                />
            </p>

            <a
                class="btn btn_action btn_close"
                :title="$gettext('Zavřít')"
                @click.prevent="$emit('close')"
            >
                {{ $gettext('Zavřít') }}
            </a>
        </div>
    </div>
</template>

<script>


export default {
  components: {  },
  name: 'tv-station-filter-popup',
  props: {
    tvStations: {
      type: Array,
      required: true
    }
  },
  created() {
      this.selectedTvStations = [...this.tvStations]
      this.sortedTvStations = [...this.tvStations]
      this.sortedTvStations.sort((tvStation1, tvStation2) => tvStation1.name.toLowerCase() > tvStation2.name.toLowerCase() ? 1 : -1 )
  },
  data() {
    return {
        selectedTvStations: [],
        sortedTvStations: [],
        search: ''
    }
  },
  computed: {

  },
  methods: {
      tvStationChanged(checked, tvStation) {
          if (checked) {
              this.selectedTvStations.push(tvStation)
          } else {
              let index = this.selectedTvStations.indexOf(tvStation)
              if (index !== -1) {
                  this.selectedTvStations.splice(index, 1)
              }
          }
      },
      isTvStationShown(tvStation) {
          return this.search.length == 0 || tvStation.name.toLowerCase().includes(this.search.toLowerCase())
      },
      clearSearch() {
          this.search = ''
      }
  }
}
</script>
